import * as actionType from "../constants";

export const dispatchAttachment =
  (input, any = null) =>
  async (dispatch) => {
    if (any === "status") {
      return;
    }
    dispatch({
      type: actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD,
      payload: input,
    });
  };
